module.exports = __webpack_public_path__ + "static/media/camera-off.ff55f50d.svg";